"use client";
import FormControlLabel, {
  type FormControlLabelProps,
} from "@/components/common/formElements/library/FormControlLabel";
import RadioControl from "./RadioControl";

export interface RadioProps extends Omit<FormControlLabelProps, "control"> {
  control?: FormControlLabelProps["control"];
}

export default function Radio(props: RadioProps) {
  return <FormControlLabel control={<RadioControl />} {...props} />;
}
